/* eslint-disable unicorn/no-null */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable unicorn/prefer-ternary */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const aObjectToFormdata = (payload, form = null, namespace = null) => {
    const formatData = form || new FormData();
    let formKey = null;
    Object.keys(payload).forEach((key) => {
        if (namespace) {
            formKey = `${namespace}[${key}]`;
        }
        else {
            formKey = key;
        }
        if (typeof payload[key] === 'object' && !(payload[key] instanceof File)) {
            aObjectToFormdata(payload[key], formatData, key);
        }
        else {
            formatData.append(formKey, payload[key]);
        }
    });
    return formatData;
};
